<script lang="ts">
  import PoiResults from "$lib/components/search/poi-results.svelte";
  import PlaceResults from "$lib/components//search/place-results.svelte";
  import { searchStore } from "$lib/stores/search.svelte";
  import { detailsStore } from "$lib/stores/details.svelte";
  import { stateStore } from "$lib/stores/state.svelte";
  import { locationStore } from "$lib/stores/location.svelte";
  import { type PlaceResult } from "$lib/types/place.types";
  import type { PoiItem } from "$lib/types";

  let activeTab = $derived(searchStore.activeTab);

  function handlePoiClick(item: PoiItem) {
    detailsStore.select([item]);
    stateStore.openDetail();
  }

  function handlePlaceClick(place: PlaceResult) {
    // Center map on the selected place
    locationStore.centerMapOn(
      { lat: place.lat, lng: place.lon },
      place.type === "city" ? 12 : place.type === "town" ? 13 : 14
    );

    // Close search
    stateStore.activePage = null;
  }

  function setTab(tab: "pois" | "places") {
    searchStore.setActiveTab(tab);
  }
</script>

<div class="h-full flex flex-col">
  <!-- Tab Navigation -->
  <div class="flex border-b-2 border-foreground">
    <button
      class="flex-1 py-3 px-4 font-bold transition-all
             {activeTab === 'pois'
        ? 'bg-primary text-primary-foreground border-b-4 border-primary-foreground'
        : 'text-foreground hover:bg-accent/20'}"
      onclick={() => setTab("pois")}
    >
      Ökos pontok
      {#if searchStore.filteredSearchResults.length > 0}
        <span class="ml-1 text-sm"
          >({searchStore.filteredSearchResults.length})</span
        >
      {/if}
    </button>

    <button
      class="flex-1 py-3 px-4 font-bold transition-all
             {activeTab === 'places'
        ? 'bg-primary text-primary-foreground border-b-4 border-primary-foreground'
        : 'text-foreground hover:bg-accent/20'}"
      onclick={() => setTab("places")}
    >
      Helyek
      {#if searchStore.placeResults.length > 0}
        <span class="ml-1 text-sm">({searchStore.placeResults.length})</span>
      {/if}
    </button>
  </div>

  <!-- Results Content -->
  <div class="flex-1 overflow-y-auto pt-2">
    {#if searchStore.error}
      <div
        class="bg-destructive/10 border border-destructive/20 text-destructive px-4 py-3 rounded-lg"
      >
        <p class="text-sm">{searchStore.error}</p>
      </div>
    {:else if activeTab === "pois"}
      <PoiResults
        items={searchStore.filteredSearchResults}
        isLoading={searchStore.isLoading}
        hasMore={searchStore.hasMore}
        onLoadMore={() =>
          searchStore.loadMore(
            locationStore.userLocation?.lat,
            locationStore.userLocation?.lng
          )}
        onItemClick={handlePoiClick}
      />
    {:else}
      <PlaceResults
        items={searchStore.placeResults}
        isLoading={searchStore.isLoading}
        hasMore={searchStore.placeHasMore}
        onLoadMore={() => searchStore.loadMorePlaces()}
        onItemClick={handlePlaceClick}
      />
    {/if}
  </div>
</div>
